import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import { pcsNotificationsQuery } from '@app/pcs/shared/notifications/data/notifications-queries';

@Injectable()
export class NotificationsDataService {

  constructor(private graphQLService: GraphqlService) {
  }

  fetchPcsNotifications() {
    return this.graphQLService.query(pcsNotificationsQuery, {}, hideLoader());
  }
}
